/* Zet alle koopknoppen op deze pre-order pagina op "Pre-order" en bewaakt dat
   label tegen het overschrijven door de theme-scripts (sticky-atc updateStickyAtc,
   product.js loading-reset via data-atc-text). Alleen geladen op de
   wk-shirt-pre-order template. */
(function () {
  var LABEL = 'Pre-order';

  function isSoldOut(btn) {
    if (btn.classList.contains('disabled') || btn.disabled) return true;
    var t = (btn.querySelector('.m-add-to-cart--text') || {}).textContent || '';
    t = t.trim().toLowerCase();
    return t === 'uitverkocht' || t === 'sold out' || t === 'niet beschikbaar';
  }

  function relabel() {
    document.querySelectorAll('.m-add-to-cart').forEach(function (btn) {
      var span = btn.querySelector('.m-add-to-cart--text');
      if (!span) return;
      // Houd het data-atc-text attribuut altijd op Pre-order, zodat de
      // loading-reset niet terugvalt op "In winkelwagen".
      if (btn.getAttribute('data-atc-text') !== LABEL) btn.setAttribute('data-atc-text', LABEL);
      if (isSoldOut(btn)) return; // echt uitverkocht laten staan
      if (span.textContent.trim() !== LABEL) span.textContent = LABEL;
    });
  }

  function boot() {
    relabel();

    // Her-toepassen na variant-/voorraadwissel (theme zet label dan opnieuw).
    document.addEventListener('variant:changed', function () { setTimeout(relabel, 0); });
    var sel = document.querySelector('.m-sticky-addtocart select[name="id"]');
    if (sel) sel.addEventListener('change', function () { setTimeout(relabel, 0); });

    // Bewaak de labels tegen elke latere herschrijving.
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { relabel(); });
      document.querySelectorAll('.m-add-to-cart--text').forEach(function (el) {
        mo.observe(el, { childList: true, characterData: true, subtree: true });
      });
    }

    // Veiligheidsnet voor de eerste seconden (theme-init kan later draaien).
    var n = 0;
    var iv = setInterval(function () { relabel(); if (++n > 12) clearInterval(iv); }, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
